
import { defineComponent, PropType } from 'vue'
import { CardType } from '@/types/Card'
import ExchangeIcon from '@/components/Icons/ExchangeIcon.vue'
import VisaIcon from '@/components/Icons/VisaIcon.vue'
import MastercardIcon from '@/components/Icons/MastercardIcon.vue'
import ChipIcon from '@/components/Icons/ChipIcon.vue'

export default defineComponent({
  name: 'Card',
  components: {
    ExchangeIcon,
    VisaIcon,
    MastercardIcon,
    ChipIcon,
  },
  props: {
    card: {
      type: Object as PropType<CardType>,
      required: true,
    },
  },
  setup({ card }) {
    const { num } = card
    const prevDigits = num.toString().slice(-8, -4)
    const lastDigits = num.toString().slice(-4)

    return {
      prevDigits,
      lastDigits,
    }
  },
})
